import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { BACKEND_URL } from '../config';
import PackageView from '../components/site/PackageView';
import { SitePage, PageHero, PageLoading } from '../components/site/ui';

/** /destination/:destinationId/package/:packageId */
const PackageDetailPage = () => {
  const { destinationId, packageId } = useParams();
  const [pkg, setPkg] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    axios.get(`${BACKEND_URL}/api/tours/${destinationId}/packages/${packageId}`)
      .then((r) => { if (alive) setPkg(r.data?.package || null); })
      .catch(() => { if (alive) setPkg(null); })
      .finally(() => alive && setLoading(false));
    return () => { alive = false; };
  }, [destinationId, packageId]);

  if (loading) return <PageLoading />;
  if (!pkg) {
    return (
      <SitePage>
        <PageHero short title="Package" accent="not found" lede="This package may have been updated or removed. Browse our current packages or ask us for a custom plan.">
          <Link className="vk-btn vk-btn--hot" to="/tour-packages">See all packages</Link>
        </PageHero>
      </SitePage>
    );
  }
  return <PackageView pkg={pkg} destinationId={destinationId} canonicalPath={`/destination/${destinationId}/package/${packageId}`} />;
};

export default PackageDetailPage;
